import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Listens to url param='mode' if 'create' then sets the initialValues as
// getInitVals := function that returns a promise..
const useInitialValuesHavingModeAsUrlParam = (defaultInitialValues, getInitialValues, responseMiddleware = {}) => {
   const [initialValues, setInitialValues] = useState(undefined);
   const [isFetching, setIsFetching] = useState(true);
   const [numToRefresh, setNumToRefresh] = useState();

   const { mode, id } = useParams();


   const reloadInitialValues = useCallback(() => {
      setNumToRefresh(Date.now());
   }, []);

   useEffect(() => {
      if (mode === 'edit') {
         getInitialValues(id)().then((res) => {
            const data = res?.data;
            const newInitialValues = responseMiddleware?.get ? responseMiddleware.get(data) : data;
            setInitialValues(newInitialValues);
            setIsFetching(false);
         });
      } else if (mode === 'create') {
         setInitialValues(defaultInitialValues);
         setIsFetching(false);
      } else {
         console.error('Unhandled mode URL param.');
      }
   }, [mode, id, numToRefresh]);

   return ({
      initialValues,
      isFetching,
      reloadInitialValues,
   });
};

export default useInitialValuesHavingModeAsUrlParam;
